import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取trucking 下的装箱明细
export function queryByTruckingInfo(params) {
  return request({
    url: URL.seaExport.containerUsageQueryByTruckingInfo,
    method: 'get',
    params
  })
}

// 根据jobUuid查询装箱明细
export function containerUsagesByJobUuid(params) {
  return request({
    url: URL.seaExport.containerUsagQueryByJobUuid,
    method: 'get',
    params
  })
}

// 获取job 下未trucking 下的装箱明细
export function queryByUnTruckingInfo(params) {
  return request({
    url: URL.seaExport.queryByUnTruckingInfo,
    method: 'get',
    params
  })
}

// 装箱明细添加truckingInfoUuid
export function updateContaierUsageLinkedTruckingInfo(data) {
  return request({
    url: URL.seaExport.updateContaierUsageLinkedTruckingInfo,
    method: 'post',
    data
  })
}

// 装箱明细移除truckingInfoUuid
export function delContaierUsageLinkedTruckingInfo(data) {
  return request({
    url: URL.seaExport.delContaierUsageLinkedTruckingInfo,
    method: 'post',
    data
  })
}

// 获取job 下未trucking 下的装箱明细
export function queryByUnSpecialGoods(params) {
  return request({
    url: URL.seaExport.queryByUnSpecialGoods,
    method: 'get',
    params
  })
}

// 危险品-查看关联业务
export function querySpecialAssociatedBusiness(data) {
  return request({
    url: URL.seaExport.querySpecialAssociatedBusiness,
    method: 'post',
    data
  })
}

// 危险品-查看关联业务-同步
export function synchronizationSpecialContainer(params) {
  return request({
    url: URL.seaExport.synchronizationSpecialContainer,
    method: 'post',
    params
  })
}

// 查看关联业务
export function queryAssociatedBusiness(data) {
  return request({
    url: URL.seaExport.queryAssociatedBusiness,
    method: 'post',
    data
  })
}
// 查看关联业务-同步
export function synchronizationContainer(data) {
  return request({
    url: URL.seaExport.synchronizationContainer,
    method: 'post',
    data
  })
}

export function synchronizationSendMessage(data) {
  return request({
    url: URL.seaExport.synchronizationSendMessage,
    method: 'post',
    data
  })
}

// 导入excel
export function importExcelData(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.seaExport.usageImportExcelData,
    config: {
      headers: {
        'Content-Type': 'multipart/form-data; charset=UTF-8'
      }
    },
    method: 'post',
    data
  })
}

// 集装箱运行轨迹查询
export function queryContainerTrajectoryList(data) {
  return request({
    url: URL.seaExport.queryContainerTrajectoryList,
    method: 'post',
    data
  })
}

// 集装箱运行轨迹数量
export function queryContainerTrajectoryNum() {
  return request({
    url: URL.seaExport.queryContainerTrajectoryNum,
    method: 'get'
  })
}

// 集装箱运行轨迹 更新异常状态
export function updateContainerErrorNode(data) {
  return request({
    url: URL.seaExport.updateContainerErrorNode,
    method: 'post',
    data
  })
}

// 根据jobUuid获取港区数据
export function getGoodsTmpInfoByJobId(params) {
  return request({
    url: URL.seaExport.getGoodsTmpInfoByJobId,
    method: 'get',
    params
  })
}

export function queryByManifestInfoIdAndDataType(params) {
  return request({
    url: URL.seaExport.queryByManifestInfoIdAndDataType,
    method: 'get',
    params
  })
}

// 更新港区数据校验信息状态
export function updateDataState(data) {
  return request({
    url: URL.seaExport.updateDataState,
    method: 'post',
    data
  })
}

// 校验港区数据是否已读
export function checkRead(params) {
  return request({
    url: URL.seaExport.checkRead,
    method: 'get',
    params
  })
}

// 将港区数据标记为已读
export function updateRead(params) {
  return request({
    url: URL.seaExport.updateRead,
    method: 'get',
    params
  })
}
